"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usidStorageKey = exports.tokenStorageKey = exports.refreshTokenRegisteredStorageKey = exports.refreshTokenGuestStorageKey = exports.oidStorageKey = exports.encUserIdStorageKey = exports.dwSessionIdKey = exports.cidStorageKey = exports.REFRESH_TOKEN_COOKIE_AGE = exports.INVALID_TOKEN = exports.IFRAME_HOST_ALLOW_LIST = exports.EXPIRED_TOKEN = exports.DNT_CT_COOKIE_NAME = exports.DNT_COOKIE_NAME = exports.ACTIVE_DATA_ENABLED = void 0;
/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

const usidStorageKey = exports.usidStorageKey = 'usid';
const cidStorageKey = exports.cidStorageKey = 'cid';
const encUserIdStorageKey = exports.encUserIdStorageKey = 'enc-user-id';
const tokenStorageKey = exports.tokenStorageKey = 'token';
const refreshTokenRegisteredStorageKey = exports.refreshTokenRegisteredStorageKey = 'cc-nx';
const refreshTokenGuestStorageKey = exports.refreshTokenGuestStorageKey = 'cc-nx-g';
const oidStorageKey = exports.oidStorageKey = 'oid';
const dwSessionIdKey = exports.dwSessionIdKey = 'dwsid';
const REFRESH_TOKEN_COOKIE_AGE = exports.REFRESH_TOKEN_COOKIE_AGE = 90; // 90 days. This value matches SLAS cartridge.
const EXPIRED_TOKEN = exports.EXPIRED_TOKEN = 'EXPIRED_TOKEN';
const INVALID_TOKEN = exports.INVALID_TOKEN = 'invalid refresh_token';
const DNT_COOKIE_NAME = exports.DNT_COOKIE_NAME = 'dw_dnt';
const DNT_CT_COOKIE_NAME = exports.DNT_CT_COOKIE_NAME = '__cq_dnt';

/**
 * This list contains domains that can host code in iframe
 */
const IFRAME_HOST_ALLOW_LIST = exports.IFRAME_HOST_ALLOW_LIST = Object.freeze(['https://runtime.commercecloud.com', 'https://runtime-admin-staging.mobify-storefront.com', 'https://runtime-admin-preview.mobify-storefront.com']);

// Constant to Enable Active Data
const ACTIVE_DATA_ENABLED = exports.ACTIVE_DATA_ENABLED = true;